import { render, staticRenderFns } from "./AdsPutInProd.vue?vue&type=template&id=795e7500"
import script from "./AdsPutInProd.vue?vue&type=script&lang=js"
export * from "./AdsPutInProd.vue?vue&type=script&lang=js"
import style0 from "./AdsPutInProd.vue?vue&type=style&index=0&id=795e7500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports